import { render } from "./EmptyNotification.vue?vue&type=template&id=56ff84f0&scoped=true"
const script = {}

import "./EmptyNotification.vue?vue&type=style&index=0&id=56ff84f0&scoped=true&lang=scss"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ff84f0"]])

export default __exports__